import { render, staticRenderFns } from "./create-batch-btn.vue?vue&type=template&id=85a41576&"
import script from "./create-batch-btn.vue?vue&type=script&lang=js&"
export * from "./create-batch-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports